import React from 'react';
import { Button, Space, Typography } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { MassBroadcastsProps } from '../service/broadcasts.interface';
import { convertTelegrammMenuToArray } from '../../../utils/convertTelegrammMenuToArray';
import { downloadChatIdsXls } from './downloadChatIdsXls';
import { getLocalDate } from '../../../utils/getLocalDate';
import { broadcastSegmentationNames, broadcastStatusNames } from './options';

const { Text } = Typography;

const StyledImageWrapper = styled.div`
    border-radius: 5px;
    border: 1px solid rgba(37, 33, 41, 0.15);
    background: #fff;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 104px;
    height: 104px;
`;

const StyledImage = styled.img`
    max-width: 100%;
    max-height: 100%;
`;

export const getContentBlocks = (data: MassBroadcastsProps) => {
    const linksArray = convertTelegrammMenuToArray(data?.content?.menu);

    return [
        {
            name: 'Сегментация',
            component: broadcastSegmentationNames[data?.segmentation] || '-',
        },
        {
            name: 'Список ID',
            component: (
                <a onClick={() => downloadChatIdsXls(data?.chat_ids)}>
                    telegramIds.xls
                </a>
            ),
        },
        {
            name: 'Результат',
            component: (
                <>
                    {data?.total_sends || '-'} /{' '}
                    {data?.total_sends - data?.failed_sends || '-'} /{' '}
                    {data?.failed_sends || '-'}
                </>
            ),
            tooltip: 'Запланировано/Успешно/Не успешно',
            icon: <QuestionCircleOutlined />,
        },
        {
            name: 'Изображение',
            component: data?.content?.media_url ? (
                <StyledImageWrapper>
                    <StyledImage src={data?.content?.media_url} />
                </StyledImageWrapper>
            ) : (
                '-'
            ),
        },
        {
            name: 'Сообщение рассылки:',
            component: (
                <span
                    dangerouslySetInnerHTML={{
                        __html:
                            data?.content?.media_caption ||
                            data?.content?.message,
                    }}
                />
            ),
        },
        ...(linksArray?.length > 0
            ? linksArray.flatMap(item => [
                  {
                      name: 'Название кнопки',
                      component: <Text>{item.linkKey}</Text>,
                  },
                  {
                      name: 'URL кнопки',
                      component: <Text>{item.linkValue}</Text>,
                  },
              ])
            : []),
        {
            name: 'Статус',
            component: (
                <Button
                    size='small'
                    style={{ cursor: 'not-allowed', pointerEvents: 'none' }}
                >
                    <Space>{broadcastStatusNames[data?.status]}</Space>
                </Button>
            ),
        },
        {
            name: 'Дата отправки',
            component: data?.send_at ? getLocalDate(data?.send_at) : '-',
        },
    ];
};
